import React from 'react';
import { FormattedMessage } from 'react-intl';
import { makeStyles } from '@material-ui/core/styles';

import LandingSection from '../../../MyComponents/LandingSections/LandingSection';
import SectionEyebrow from '../../../MyComponents/LandingSections/SectionEyebrow';
import HighlightMark from '../../../MyComponents/LandingSections/HighlightMark';
import CreateGroupForm from '../../ManageClass/CreateGroupForm';
import { REDESIGN_COLORS, REDESIGN_FONTS } from '../../../constants';

const useStyles = makeStyles(() => ({
    intro: {
        maxWidth: '760px',
        marginBottom: '28px',
    },
    eyebrowRow: {
        marginBottom: '18px',
    },
    title: {
        margin: '0 0 12px',
        fontSize: 'clamp(1.9rem, 3.6vw, 2.8rem)',
        lineHeight: 1.1,
        letterSpacing: '-0.035em',
        fontWeight: REDESIGN_FONTS.weightHeading,
        color: REDESIGN_COLORS.dark,
        textWrap: 'balance',
    },
    lead: {
        maxWidth: '620px',
        margin: 0,
        color: REDESIGN_COLORS.body,
        fontSize: '1.04rem',
        lineHeight: 1.6,
    },
}));

/**
 * The top of the signed-in home: the greeting and the one action most visits
 * are for, starting a new group.
 */
const DashboardHero = ({ givenName }) => {
    const classes = useStyles();

    return (
        <LandingSection id="top" background="none" gutter={0} paddingTop={8} paddingBottom={24}>
            <div className={classes.intro}>
                <div className={classes.eyebrowRow}>
                    <SectionEyebrow>
                        <FormattedMessage id="redesign.home.dashboard.eyebrow" />
                    </SectionEyebrow>
                </div>
                <h1 className={classes.title}>
                    <FormattedMessage
                        id="redesign.home.dashboard.title"
                        values={{ givenName, mark: (chunks) => <HighlightMark>{chunks}</HighlightMark> }}
                    />
                </h1>
                <p className={classes.lead}>
                    <FormattedMessage id="redesign.home.dashboard.lead" />
                </p>
            </div>

            <CreateGroupForm />
        </LandingSection>
    );
};

export default DashboardHero;
